module.exports = __webpack_public_path__ + "static/media/Closed Captions Test_1633877100665.36621042.vtt";